import { useWorkflowChrome } from '../components/Layout/WorkflowChromeContext';
import { usePeriodRefresh } from './usePeriodRefresh';

/** Refresh a period from code outside the workflow chrome, unless the chrome already shows it. */
export function usePeriodLiveRefresh(periodId: string | undefined): void {
  const { periodId: chromePeriodId } = useWorkflowChrome();
  usePeriodRefresh(periodId === chromePeriodId ? undefined : periodId);
}
